import { render } from "./ScriptTable.vue?vue&type=template&id=0ed75b66"
import script from "./ScriptTable.vue?vue&type=script&lang=js"
export * from "./ScriptTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__